export enum NatureOfComplaintDomestic {
  ORDER_ENTRY = 'Order Entry',
  ITEM_OR_QUANTITY = 'Item or Quantity',
  PRODUCT_DATING = 'Product Dating',
  PRODUCT_DAMAGE = 'Product Damage',
  PRODUCT_TEMPERATURE = 'Product Temperature',
  DELIVERY = 'Delivery',
  INVOICE_ERROR = 'Invoice Error',
  BILLING_ADJUSTMENT = 'Billing Adjustment',
  ESKER = 'Esker',
  LARGE_INSTRUMENT_WAREHOUSE = 'Large Instrument Warehouse',
}
